import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
interface DentosHeaderProps {
  currentPage: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo';
  onNavigate: (page: 'home' | 'knowledge' | 'tools' | 'research' | 'dental-kids' | 'logo') => void;
}
export function DentosHeader({
  currentPage,
  onNavigate
}: DentosHeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Главная',
    page: 'home',
    href: '#'
  }, {
    name: 'База знаний',
    page: 'knowledge',
    href: '#'
  }, {
    name: 'Исследования',
    page: 'research',
    href: '#'
  }, {
    name: 'Инструменты',
    page: 'tools',
    href: '#'
  }, {
    name: 'Dental Kids',
    page: 'dental-kids',
    href: '#'
  }];
  const handleNavClick = (e: React.MouseEvent, link: {
    name: string;
    page: string;
    href: string;
  }) => {
    e.preventDefault();
    if (link.page === 'knowledge') {
      onNavigate('knowledge');
      window.scrollTo(0, 0);
    } else if (link.page === 'tools') {
      onNavigate('tools');
      window.scrollTo(0, 0);
    } else if (link.page === 'research') {
      onNavigate('research');
      window.scrollTo(0, 0);
    } else if (link.page === 'dental-kids') {
      onNavigate('dental-kids');
      window.scrollTo(0, 0);
    } else {
      onNavigate('home');
      if (currentPage === 'home') {
        if (link.href && link.href !== '#') {
          const element = document.querySelector(link.href);
          if (element) element.scrollIntoView({
            behavior: 'smooth'
          });else window.scrollTo(0, 0);
        } else {
          window.scrollTo(0, 0);
        }
      } else {
        setTimeout(() => {
          if (link.href && link.href !== '#') {
            const element = document.querySelector(link.href);
            if (element) element.scrollIntoView({
              behavior: 'smooth'
            });else window.scrollTo(0, 0);
          } else {
            window.scrollTo(0, 0);
          }
        }, 100);
      }
    }
    setIsMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0F1E3C] shadow-lg py-3' : 'bg-[#0F1E3C] py-5'}`} data-id="element-53">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-54">
        <div className="cursor-pointer flex items-center gap-2" onClick={() => onNavigate('home')} data-id="element-55">
          {/* Inline SVG symbol */}
          <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-56">
            <rect x="8" y="8" width="4" height="24" rx="2" fill="#00C2D4" data-id="element-57" />
            <rect x="14" y="18" width="4" height="14" rx="2" fill="#00C2D4" data-id="element-58" />
            <rect x="20" y="13" width="4" height="19" rx="2" fill="#00C2D4" data-id="element-59" />
            <rect x="26" y="8" width="4" height="24" rx="2" fill="#00C2D4" data-id="element-60" />
          </svg>
          <span style={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 800,
          fontSize: '18px',
          letterSpacing: '3px',
          color: '#FFFFFF'
        }} data-id="element-61">
            DENTOS
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-62">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link)} className={`text-sm font-medium transition-colors ${currentPage === 'knowledge' && link.name === 'База знаний' || currentPage === 'tools' && link.name === 'Инструменты' || currentPage === 'research' && link.name === 'Исследования' || currentPage === 'dental-kids' && link.name === 'Dental Kids' || currentPage === 'home' && link.name === 'Главная' ? 'text-[#00C2D4]' : 'text-gray-300 hover:text-[#00C2D4]'}`} data-id="element-63">
              {link.name}
            </a>)}
        </nav>

        {/* Mobile Menu Button */}
        <button className="lg:hidden text-white p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-64">
          {isMenuOpen ? <X size={24} data-id="element-65" /> : <Menu size={24} data-id="element-66" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {isMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-[#0F1E3C] border-t border-gray-800 p-4 shadow-xl" data-id="element-67">
          <div className="flex flex-col space-y-4" data-id="element-68">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`font-medium py-2 ${currentPage === 'knowledge' && link.name === 'База знаний' || currentPage === 'tools' && link.name === 'Инструменты' || currentPage === 'research' && link.name === 'Исследования' || currentPage === 'dental-kids' && link.name === 'Dental Kids' || currentPage === 'home' && link.name === 'Главная' ? 'text-[#00C2D4]' : 'text-gray-300 hover:text-[#00C2D4]'}`} onClick={e => handleNavClick(e, link)} data-id="element-69">
                {link.name}
              </a>)}
          </div>
        </div>}
    </header>;
}